module.exports = __webpack_public_path__ + "static/usa-map-8b78c2dceec1cfdf0e0e7f1e0a13cbb2.png";